export const OPPORTUNITIES_KANBAN_NAME = 'opportunities';
